// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"28":"d5d8ace6","154":"09977077","250":"85130604","443":"96e62a2c","551":"8002ff2b","584":"3f7791e5","658":"2b4b4bf6","730":"172128ed","767":"40245b86","773":"19ce1001","787":"e5486da8","821":"71bb1762","947":"ac790acf"}[chunkId] + ".js";
};